import React from 'react';
import MarkdownDocPage from '../../components/docs/MarkdownDocPage';
import content from '../../content/sentry-docs/analytics/balance.md?raw';

const AnalyticsBalance: React.FC = () => {
  return <MarkdownDocPage content={content} />;
};

export default AnalyticsBalance;
